import React from "react";
import { useNavigate } from "react-router-dom";

import {
    UserPen,
    Settings,
    Lock,
    CircleHelp,
    LogOut,
    ChevronRight
} from "lucide-react";

import "./ProfileActions.css";

function ProfileActions() {

    const navigate = useNavigate();

    const actions = [

        {
            title: "Edit Profile",
            subtitle: "Update your personal information",
            icon: <UserPen size={22} />,
            route: "/delivery/edit-profile",
        },

        {
            title: "Settings",
            subtitle: "Notifications, Language & Theme",
            icon: <Settings size={22} />,
            route: "/delivery/settings",
        },

        {
            title: "Change Password",
            subtitle: "Keep your account secure",
            icon: <Lock size={22} />,
            route: "/delivery/change-password",
        },

        {
            title: "Help & Support",
            subtitle: "Need assistance?",
            icon: <CircleHelp size={22} />,
            route: "/delivery/support",
        },

    ];

    const handleLogout = () => {

        localStorage.clear();

        navigate("/login");

    };

    return (

        <div className="hf-actions-card">

            <div className="hf-actions-header">

                <h2>

                    Account Settings

                </h2>

                <p>

                    Manage your HomeFoods account

                </p>

            </div>

            <div className="hf-actions-list">

                {

                    actions.map((item, index) => (

                        <div

                            key={index}

                            className="hf-action-item"

                            onClick={() => navigate(item.route)}

                        >

                            <div className="hf-action-left">

                                <div className="hf-action-icon">

                                    {item.icon}

                                </div>

                                <div className="hf-action-content">

                                    <h4>

                                        {item.title}

                                    </h4>

                                    <p>

                                        {item.subtitle}

                                    </p>

                                </div>

                            </div>

                            <ChevronRight size={20} />

                        </div>

                    ))

                }

            </div>

            <button

                className="hf-logout-btn"

                onClick={handleLogout}

            >

                <LogOut size={20} />

                Logout

            </button>

        </div>

    );

}

export default ProfileActions;